import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { trackRouteView } from ".";

let lastTrackedRouteKey: string | null = null;

const RouteAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    const surface = location.pathname.startsWith("/kiosk") ? "kiosk" : "web";
    const routeKey = `${surface}:${location.pathname}`;
    if (routeKey === lastTrackedRouteKey) return;

    lastTrackedRouteKey = routeKey;
    trackRouteView({
      pathname: location.pathname,
      search: location.search,
      surface,
    });
  }, [location.pathname, location.search]);

  return null;
};

export const __resetRouteAnalyticsForTests = () => {
  lastTrackedRouteKey = null;
};

export default RouteAnalytics;
